import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import type { ImmutableEntity, Langcodes } from '@uncinc/react-drupal-core/types';

import Card from '../../../../../components/Card';
import type { NodeActivity } from '../../../../../types/uncinc_profile/nodes';

interface NodeActivityTeaserBuurtboerderijProps {
  entity: ImmutableEntity<NodeActivity>;
}

// eslint-disable-next-line max-len
const NodeActivityTeaserBuurtboerderij: React.FC<NodeActivityTeaserBuurtboerderijProps> = ({ entity }) => {
  const { t } = useTranslation();

  const node = entity.toJS();
  // @TODO: Fix this typing in RDC.
  const language = node.langcode[0].value as any as Langcodes;
  const path = node.paths[language];
  const title = node.title[0].value;
  const body = node.body[0]?.processed;
  const image = node.field_image[0].styles.ratio_4_3_sm;
  const date = node.field_date_description[0]?.value;
  const organization = node.field_organization[0]?.title;
  const classNames = c('NodeActivityTeaser', 'NodeActivityTeaser--Buurtboerderij');

  return (
    <Card
      className={classNames}
      link={path}
      label={date}
      title={title}
      subtitle={organization && t('activity.by_organization', { organization })}
      body={body}
      image={image}
    />
  );
};

export default NodeActivityTeaserBuurtboerderij;
